import { Comments } from '../components/Comments';
import { createEntry } from '../helpers/entries';

createEntry({
  component: Comments,
  name: 'Comments',
});
